// extracted by mini-css-extract-plugin
export default {"wrap":"Thzsy4McniXob9_7tpqQ"};